import { createCommands } from '@tdp/common/commandHandler';
import { nextCallStack } from '@tdp/common/shared';

import { SupportedLocale } from './models';
import { LocaleStringFetcher } from './service';
import { localizationSlice } from './slice';

export interface CreateLocalizationCommandHandlerDependencies {
  localeStringFetcher: LocaleStringFetcher;
}
export const createLocalizationCommandHandler = ({
  localeStringFetcher,
}: CreateLocalizationCommandHandlerDependencies) =>
  createCommands({
    name: 'localeCommands',
    handlers: {
      async *updateCurrentLocale(locale: SupportedLocale) {
        await nextCallStack();
        yield localizationSlice.actions.currentLocaleUpdated(locale);
      },
      //TODO(nibeauli): use proper telemetry logging rather than console
      //TODO(nibeauli): add handlers for loading locally cached/saved locales
      async *loadLocaleStrings(locale: SupportedLocale) {
        console.log('Attempting to load locale %s', locale);
        const localeStrings = await localeStringFetcher(locale);
        if (localeStrings.type !== 'success') {
          console.error('Failed to load locale strings', localeStrings);
          return;
        }
        yield localizationSlice.actions.localeLoaded(
          localeStrings.localeStrings
        );
      },
    },
  });
